import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "21",
  fill: "none",
  viewBox: "0 0 17 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#5F6A7D",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2.25",
      d: "M8.191 1.125a7.066 7.066 0 0 0-7.066 7.066c0 1.742.633 3.335 1.679 4.567l5.387 6.345 5.387-6.346a7.03 7.03 0 0 0 1.68-4.566A7.066 7.066 0 0 0 8.19 1.125",
      fill: "none"
    }, null, -1)
  ]))]))
}
export default { render: render }